import React from "react";
import { Modal, Button } from "antd";
import { MailOutlined } from "@ant-design/icons";

const AcknowledgmentModal = ({ visible, onClose, acknowledgmentData }) => {
  const formattedDate = acknowledgmentData?.date
    ? new Date(acknowledgmentData.date).toDateString()
    : "";

  const handlePrint = () => {
    const printWindow = window.open("", "_blank");

    printWindow.document.write(`
      <html>
      <head>
        <title>Print Petition</title>
        <style>
          @media print {
            body, html {
              width: 210mm;
              height: 297mm;
              margin: 0;
              padding: 0;
              font-family: Arial, sans-serif;
              -webkit-print-color-adjust: exact;
            }
            .print-container {
                width: 100%;
                height: 100%;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding: 10mm;
              }
            .header1 {
              text-align: center;
              margin-bottom: 10px;
            }
            .header-row {
              position: relative;
              margin-bottom: 10px;
              text-align: center;
            }
            .date-block {
              position: absolute;
              right: 0;
              top: 6px;
              text-align: right;
              white-space: nowrap;
              font-size: 14px;
              line-height: 1.2;
            }
            .date-block .date-label {
              font-weight: 700;
            }
            .date-block .date-value {
              font-weight: 400;
              font-size: 14px;
            }
            .heading {
              text-align: center;
              font-size: 24px;
              font-weight: bold;
              margin-bottom: 20px;
            }
            .content-container {
              margin-bottom: 20px;
            }
            .row {
              display: flex;
              margin-bottom: 10px;
            }
            .label {
              width: 200px;
              font-weight: bold;
            }
            .content {
              flex: 1;
            }
            .footer-container {
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
              font-size: 14px;
              text-align: center;
              position: relative;
            }
            .divider {
              border-top: 1px dashed #000;
              margin: 30px 0;
            }
            @page {
              size: A4;
              margin: 0;
            }
          }
        </style>
      </head>
      <body>
        <div class="print-container">
          <!-- Header Section -->
          <div class="header-row">
            <img
              src="https://www.janasenaparty.org/static/jspwebsitemain/images/logo.png"
              alt="Logo"
              style="width: 70px;"
            />
            <div class="date-block">
              <span class="date-label">Date:</span>
              <span class="date-value"> ${formattedDate}</span>
            </div>
          </div>

          <!-- First Acknowledgment Section -->
          <div class="heading">Acknowledgement</div>
          <div class="content-container">
            <div class="row">
              <div class="label">Petitioner ID:</div>
              <div class="content">${acknowledgmentData.seq_id}</div>
            </div>
            <div class="row">
              <div class="label">Petitioner Name:</div>
              <div class="content">${acknowledgmentData.name}</div>
            </div>
            <div class="row">
              <div class="label">Petitioner Mobile:</div>
              <div class="content">${acknowledgmentData.mobile}</div>
            </div>
            <div class="row">
              <div class="label">Petitioner Address:</div>
              <div class="content">${acknowledgmentData.petitioner_address}</div>
            </div>
            <div class="row">
              <div class="label">Department:</div>
              <div class="content">${acknowledgmentData.department}</div>
            </div>
            <div class="row">
              <div class="label">Title:</div>
              <div class="content">${acknowledgmentData.title}</div>
            </div>
          </div>
          <div class="footer-container">
          <p>
            <strong>Contact Number:</strong> 8645293016
          </p>
          <p>
            <MailOutlined /> Email: <a href="mailto:Janavanijsp@gmail.com">Janavanijsp@gmail.com</a>
          </p>
          <p>
            Website: <a href="https://www.janasenaparty.org" target="_blank" rel="noopener noreferrer">www.janasenaparty.org</a>
          </p>
        </div>

          <div class="divider"></div> <!-- Dashed line for cutting -->

          <!-- Copy of Acknowledgment Section -->
          <div class="header-row">
            <img
              src="https://www.janasenaparty.org/static/jspwebsitemain/images/logo.png"
              alt="Logo"
              style="width: 70px;"
            />
            <div class="date-block">
              <span class="date-label">Date:</span>
              <span class="date-value"> ${formattedDate}</span>
            </div>
          </div>
          <div class="heading">Acknowledgement</div>
          <div class="content-container">
            <div class="row">
              <div class="label">Petitioner ID:</div>
              <div class="content">${acknowledgmentData.seq_id}</div>
            </div>
            <div class="row">
              <div class="label">Petitioner Name:</div>
              <div class="content">${acknowledgmentData.name}</div>
            </div>
            <div class="row">
              <div class="label">Petitioner Mobile:</div>
              <div class="content">${acknowledgmentData.mobile}</div>
            </div>
            <div class="row">
              <div class="label">Petitioner Address:</div>
              <div class="content">${acknowledgmentData.petitioner_address}</div>
            </div>
            <div class="row">
              <div class="label">Department:</div>
              <div class="content">${acknowledgmentData.department}</div>
            </div>
            <div class="row">
              <div class="label">Title:</div>
              <div class="content">${acknowledgmentData.title}</div>
            </div>
          </div>

          <!-- Footer Section -->
          <div class="footer-container">
            <p>
              <strong>Contact Number:</strong> 8645293016
            </p>
            <p>
              <MailOutlined /> Email: <a href="mailto:Janavanijsp@gmail.com">Janavanijsp@gmail.com</a>
            </p>
            <p>
              Website: <a href="https://www.janasenaparty.org" target="_blank" rel="noopener noreferrer">www.janasenaparty.org</a>
            </p>
          </div>
        </div>
      </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      width={1000}
      style={{ left: "6%" }} // Increase the modal width here
      footer={[
        <Button key="print" type="primary" onClick={handlePrint}>
          Print
        </Button>,
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      <div id="print-content">
        {/* First Section */}
        <div style={{ position: "relative", marginBottom: "10px" }}>
          <div style={{ textAlign: "center", backgroundColor: "white" }}>
            <img
              src="https://www.janasenaparty.org/static/jspwebsitemain/images/logo.png"
              alt="Logo"
              style={{ width: "70px" }}
            />
          </div>
          <div
            style={{
              position: "absolute",
              top: 6,
              right: 0,
              textAlign: "right",
              whiteSpace: "nowrap",
              fontSize: 14,
              lineHeight: 1.2,
            }}
          >
            <span style={{ fontWeight: 700 }}>Date:</span>
            <span style={{ fontWeight: 400, fontSize: 14 }}>
              {" "}
              {formattedDate}
            </span>
          </div>
        </div>

        <div className="heading">Acknowledgement</div>
        <div className="content-container">
          <div className="row">
            <div className="label">Petition ID:</div>
            <div className="content">{acknowledgmentData?.seq_id}</div>
          </div>
          <div className="row">
            <div className="label">Petitioner Name:</div>
            <div className="content">{acknowledgmentData?.name}</div>
          </div>
          <div className="row">
            <div className="label">Petitioner Mobile Number:</div>
            <div className="content">{acknowledgmentData?.mobile}</div>
          </div>
          <div className="row">
            <div className="label">Petitioner Address:</div>
            <div className="content">
              {acknowledgmentData?.petitioner_address}
            </div>
          </div>
          <div className="row">
            <div className="label">Department:</div>
            <div className="content">{acknowledgmentData?.department}</div>
          </div>
          <div className="row">
            <div className="label">Title:</div>
            <div className="content">{acknowledgmentData?.title}</div>
          </div>
        </div>

        <div
          className="footer-container"
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <p>
            <strong>Contact Number:</strong> 8645293016
          </p>
          <p>
            <MailOutlined /> Email:{" "}
            <a href="mailto:Janavanijsp@gmail.com">Janavanijsp@gmail.com</a>
          </p>
          <p>
            Website:{" "}
            <a
              href="https://www.janasenaparty.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.janasenaparty.org
            </a>
          </p>
        </div>

        <div
          className="divider"
          style={{ borderTop: "1px dashed #000", margin: "30px 0" }}
        ></div>

        {/* Second Section */}

        <div style={{ position: "relative", marginBottom: "10px" }}>
          <div style={{ textAlign: "center", backgroundColor: "white" }}>
            <img
              src="https://www.janasenaparty.org/static/jspwebsitemain/images/logo.png"
              alt="Logo"
              style={{ width: "70px" }}
            />
          </div>
          <div
            style={{
              position: "absolute",
              top: 6,
              right: 0,
              textAlign: "right",
              whiteSpace: "nowrap",
              fontSize: 14,
              lineHeight: 1.2,
            }}
          >
            <span style={{ fontWeight: 700 }}>Date:</span>
            <span style={{ fontWeight: 400, fontSize: 14 }}>
              {" "}
              {formattedDate}
            </span>
          </div>
        </div>
        <div className="heading">Acknowledgement</div>
        <div className="content-container">
          <div className="row">
            <div className="label">Petition ID:</div>
            <div className="content">{acknowledgmentData?.seq_id}</div>
          </div>
          <div className="row">
            <div className="label">Petitioner Name:</div>
            <div className="content">{acknowledgmentData?.name}</div>
          </div>
          <div className="row">
            <div className="label">Petitioner Mobile Number:</div>
            <div className="content">{acknowledgmentData?.mobile}</div>
          </div>
          <div className="row">
            <div className="label">Petitioner Address:</div>
            <div className="content">
              {acknowledgmentData?.petitioner_address}
            </div>
          </div>
          <div className="row">
            <div className="label">Department:</div>
            <div className="content">{acknowledgmentData?.department}</div>
          </div>
          <div className="row">
            <div className="label">Title:</div>
            <div className="content">{acknowledgmentData?.title}</div>
          </div>
        </div>

        <div
          className="footer-container"
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <p>
            <strong>Contact Number:</strong> 8645293016
          </p>
          <p>
            <MailOutlined /> Email:{" "}
            <a href="mailto:Janavanijsp@gmail.com">Janavanijsp@gmail.com</a>
          </p>
          <p>
            Website:{" "}
            <a
              href="https://www.janasenaparty.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.janasenaparty.org
            </a>
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default AcknowledgmentModal;
